module.exports = __webpack_public_path__ + "img/p1.194d94f7.png";